import PropTypes from 'prop-types';
import React from 'react';
import { Button } from '@eatclubapp/ec-component-library';

export const SquareButton = ({ children, onClick, ...other }) => (
  <Button
    type='standard'
    style={{
      button: {
        backgroundColor: 'white',
        padding: '5px 10px',
        border: '1px solid #000000',
        color: '#000000',
        borderRadius: '4px',
        fontWeight: '400',
        boxShadow: 'none',
        fontSize: '15px',
      },
    }}
    onClick={onClick}
    {...other}
  >
    {children}
  </Button>
);

SquareButton.defaultProps = {
  children: null,
  onClick: () => {},
};

SquareButton.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
};
